import { ProductSummaries, ProductSummary } from "types/model.types";
//
export function mergeProducts(
  base: ProductSummaries,
  updates: ProductSummaries,
): ProductSummaries {
  if (updates && updates.length === 0) return base;

  const map = new Map(base.map((p) => [p.productCode, p]));
  updates.forEach((p) => map.set(p.productCode, p));
  return Array.from(map.values());
}
//
export function mergeProductSummaries(
  base: ProductSummaries,
  updates: ProductSummaries,
): ProductSummaries {
  if (updates && updates.length === 0) return base;

  const baseMap = new Map(base.map((p) => [p.productCode, p]));
  const updatedMap = new Map(updates.map((p) => [p.productCode, p]));

  const merged: ProductSummary[] = [];

  // Step 1: Iterate base, conditionally update or remove
  for (const baseItem of base) {
    const updatedItem = updatedMap.get(baseItem.productCode);

    if (!updatedItem) {
      merged.push(baseItem); // untouched
    } else if (updatedItem.featured || updatedItem.topSelling) {
      merged.push(updatedItem); // update with new flags
    }
    // else: skip removal if both flags false
  }

  // Step 2: Add new important items not already in base
  for (const updatedItem of updates) {
    const existsInBase = baseMap.has(updatedItem.productCode);
    const isImportant = updatedItem.featured || updatedItem.topSelling;

    if (!existsInBase && isImportant) {
      merged.push(updatedItem);
    }
  }

  return merged;
}

export function debounce<T extends (...args: any[]) => void>(
  fn: T,
  delay: number,
) {
  let timer: ReturnType<typeof setTimeout> | null = null;

  const debounced = (...args: Parameters<T>) => {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      fn(...args);
      timer = null; // optional: clear reference after execution
    }, delay);
  };

  debounced.cancel = () => {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  };

  return debounced;
}
export const getProductTotalPrice = (
  product: ProductSummary,
  priceLevel = 1,
): number => {
  let total = product.unitsCtn;
  switch (priceLevel) {
    case 4:
      total *= product.sellPrice4;
      break;
    case 3:
      total *= product.sellPrice3;
      break;
    case 2:
      total *= product.sellPrice2;
      break;
    default:
      total *= product.sellPrice1;
  }
  return total;
};
export const getProductTotalPriceAsString = (
  product: ProductSummary,
  priceLevel = 1,
): string => {
  const total = getProductTotalPrice(product, priceLevel);
  return new Intl.NumberFormat("en-NZ", {
    style: "currency",
    currency: "NZD",
  }).format(total);
};
